import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { ExternalLink } from 'ui'
import { FreeFocusInside } from 'react-focus-lock'
import BarryWindowContainer from 'components/Barry/BarryComponents/BarryWindowContainer'
import useBarryDashboard from 'components/Barry/hooks/useBarryDashboard'
import useBarryViewState from 'components/Barry/hooks/useBarryController '
import DashboardBarryIcon from './DashboardBarryIcon'
import useBarryIconVisibilityDashboard from 'components/Barry/hooks/useBarryIconVisibilityDashboard'

export default function DashboardBarryDialog(): ReactElement {
  const { handleDashboardDialogToggle } = useBarryDashboard()
  const { isBarryDialogOpen } = useBarryViewState()

  useBarryIconVisibilityDashboard()

  return (
    <Flex>
      <DashboardBarryIcon
        handleToggle={handleDashboardDialogToggle}
        barryPopupMessage={
          <Text variant="size12Weight400Line138" sx={{ color: 'aliceBlue' }}>
            Hi there! I&apos;ve noticed you&apos;re provisioning Endpoints. If you&apos;d like to
            speak to a product specialist, you can schedule a call{' '}
            <ExternalLink
              data-testid="barry-popup-link"
              to={`https://meetings.hubspot.com/joe-jaghab`}
              sx={{
                color: 'aliceBlue60',
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'aliceBlue',
                },
              }}
            >
              here
            </ExternalLink>
          </Text>
        }
      />
      {isBarryDialogOpen && (
        <FreeFocusInside>
          <BarryWindowContainer handleBarryIconToggle={handleDashboardDialogToggle} />
        </FreeFocusInside>
      )}
    </Flex>
  )
}
